import { render, staticRenderFns } from "./roleOperationModal.vue?vue&type=template&id=1e61febd&scoped=true&"
import script from "./roleOperationModal.vue?vue&type=script&lang=ts&"
export * from "./roleOperationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61febd",
  null
  
)

export default component.exports